import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { FaFacebook, FaInstagram, FaTiktok, FaTwitter, FaYoutube } from "react-icons/fa";
import { IconEmail } from '../../../assets';
import { isColorLight } from '../../../utils/FunctionsGlobals';
import { trackLead } from '../../whatsAppButton/WhatsAppButton';
import styles from './Topo.module.css';

const Topo2: React.FC<{
    site: any;
    setActiveDrawer: any
}> = ({ site, setActiveDrawer }) => {

    const router = useRouter();
    const { codsite } = router.query;
    const [scrolled, setScrolled] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    /* monta listener só 1 vez */
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 50);
        onScroll();
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const handleSearch = () => {
        if (searchTerm.trim()) {
            router.push(`/imoveis/venda/-/-/-/-/${encodeURIComponent(searchTerm)}`);
        }
    };

    const handleAdvancedSearch = () => {
        router.push('/#myLink');
    };

    const hexToRgb = (hex: string) => {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    };

    const getBackgroundColor = () => {
        if (scrolled && site?.cor1) {
            const rgb = hexToRgb(site.cor1);
            return rgb ? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.9)` : site.cor1;
        }
        return 'transparent';
    };

    const getFontColor = () => {
        if (scrolled && site?.cor1) {
            const corletra = isColorLight(site?.cor1) ? site?.cor11 : site?.cor13
            return corletra;
        }
        return 'white';
    };

    const allSocials = [
        {
            href: site?.Dados?.instagram || '',
            id: 3,
            icon: <FaInstagram style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Instagram'
        },
        {
            href: site?.Dados?.facebook || '',
            id: 1,
            icon: <FaFacebook style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Facebook'
        },
        {
            href: site?.Dados?.twitter || '',
            id: 4,
            icon: <FaTwitter style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Twitter'
        },
        {
            href: site?.Dados?.tiktok || '',
            id: 5,
            icon: <FaTiktok style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Tiktok'
        },
        {
            href: site?.Dados?.youtube || '',
            id: 2,
            icon: <FaYoutube style={{fontSize: 28,fill: getFontColor()}}/>,
            rede: 'Youtube'
        },
    ];
    const openDrawer = () => {
        setActiveDrawer(true);
    };

    return (
        <nav className={styles.nav} style={{ 
            position: 'fixed', 
            top: 0, 
            width: '100%', 
            zIndex: 99,
            background: getBackgroundColor(),
            transition: 'background 0.3s ease'
        }}>
            <div className={styles.navContainer}>
                {/* Logo */}
                <Link href={codsite ? "/?codsite="+codsite : "/"} className={styles.navLogoLink}>
                    <div className={styles.navLogoContainer}>
                        {site?.url_logo ? (
                            <img
                                src={site?.url_logo}
                                alt={`Imobiliária ${site?.Dados?.empresa}`}
                                title={`Imobiliária ${site?.Dados?.empresa}`}
                                style={{ 
                                    width: '100%', 
                                    height: '100%', 
                                    objectFit: 'contain' 
                                }}
                            />
                        ) : (
                            <div className={styles.logo_empty} />
                        )}
                    </div>
                </Link>

                {/* Desktop Search - Hidden on mobile */}
                <div className={styles.navDesktopSearch}>
                    <button 
                        className={styles.navAdvancedButton}
                        onClick={handleAdvancedSearch}
                    >
                        BUSCA AVANÇADA
                    </button>
                    <div className={styles.navSearchContainer}>
                        <input
                            className={styles.navSearchInput}
                            type="search"
                            id="myplace"
                            placeholder="BUSCA POR CÓDIGO"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                        />
                        <style>
                            {`
                            #myplace::placeholder {
                                color: ${getFontColor()};
                            }
                            `}
                        </style>
                        <button 
                            className={styles.navSearchButton}
                            onClick={handleSearch}
                        >
                            OK
                        </button>
                    </div>
                </div>
                 {site?.redes_topo &&
                    <div className={styles.redes_sociais}>
                        <div className={styles.container1} style={{display: 'flex'}}>
                            {site?.id == "2321" &&
                                <a
                                    rel="noopener noreferrer"
                                    href="mailto:contato@fcaimoveis.com.br"
                                    target='_blank'
                                    title={`Navegar para o email da imobiliária`}
                                    className={styles.adjust_img1}
                                >
                                    <Image
                                        alt={`Imagem Email`}
                                        src={IconEmail}
                                        height={30}
                                        width={30}
                                    />
                                </a>
                            }
                            {allSocials?.map((v) => {
                                if (v) {
                                    if (v.href) {
                                        return (
                                            <a
                                                aria-label={v.href}
                                                rel="noopener noreferrer"
                                                key={v.id}
                                                href={v.href}
                                                title={`Navegar para o ${v.rede} da imobiliária`}
                                                onClick={async (e) => {
                                                    e.preventDefault(); // Evita o redirecionamento automático

                                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                                    setTimeout(() => {
                                                    window.open(
                                                        v.href,
                                                        "_blank"
                                                    );
                                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                                }}
                                                className={styles.adjust_img1}
                                            >
                                                {v.icon}
                                            </a>
                                        );
                                    }
                                    return null;
                                }
                                return null;
                            })}
                        </div>
                    </div>
                }
                 {/* Menu Button - Desktop */}
                <div className={styles.navMenuButton} onClick={openDrawer}>
                    <div className={styles.navMenuButtonLine} style={{backgroundColor: getFontColor()}}></div>
                    <div className={styles.navMenuButtonLine} style={{backgroundColor: getFontColor()}}></div>
                    <div className={styles.navMenuButtonLine} style={{backgroundColor: getFontColor()}}></div>
                </div>
            </div>
        </nav>
    );
};

export default Topo2;
